import { AwsUi } from '../../../core/runtime/src';
import BemClassBuilder from '../../../core/utils/src/class-builders/bem';
import { Icon } from '../../icon/src';
export var Segment = function (_a) {
    var disabled = _a.disabled, text = _a.text, iconName = _a.iconName, iconAlt = _a.iconAlt, iconUrl = _a.iconUrl, isActive = _a.isActive, onClick = _a.onClick, tabIndex = _a.tabIndex;
    var segmentClass = new BemClassBuilder({ __componentName: 'awsui-segment' })
        .modifier('awsui-hover-child-icons')
        .modifier('disabled', !!disabled)
        .modifier('selected', isActive)
        .toString();
    var hasIcon = iconName || iconUrl;
    var segmentIcon = (AwsUi.__createElement(Icon, { className: "awsui-segment__" + (text ? 'icon' : 'no-text'), name: iconName, url: iconUrl, alt: iconAlt, variant: disabled ? 'disabled' : 'normal' }));
    return (AwsUi.__createElement("button", { className: segmentClass, onclick: onClick, disabled: disabled, type: "button", "override-focus": true, tabindex: tabIndex, "aria-pressed": isActive ? 'true' : 'false', "aria-label": !text ? iconAlt : undefined },
        hasIcon ? segmentIcon : '',
        AwsUi.__createElement("span", null, text)));
};
//# sourceMappingURL=segment.js.map